var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-container"},[_c('ACHeader'),_c('router-view',{attrs:{"models":_vm.models}}),_c('ACFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }